module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "user-setting"
    }
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('form', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('form-input', {
    staticClass: "col",
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }, [_c('form-label', {
    staticClass: "col-3"
  }, [_vm._v("Name")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onApplyInfo($event)
      }
    }
  }, [_vm._v("Apply")])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('form', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('form-input', {
    staticClass: "col",
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }, [_c('form-label', {
    staticClass: "col-3"
  }, [_vm._v("Password")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('form-input', {
    staticClass: "col",
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.confirm),
      callback: function($$v) {
        _vm.confirm = $$v
      },
      expression: "confirm"
    }
  }, [_c('form-label', {
    staticClass: "col-3"
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onApplyPassword($event)
      }
    }
  }, [_vm._v("Apply")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid"
  }, [_c('h2', {
    staticClass: "col"
  }, [_vm._v("Change Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid"
  }, [_c('h2', {
    staticClass: "col"
  }, [_vm._v("Change Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e30f766"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/UserSetting.vue
// module id = 575
// module chunks = 0